import { defineStore } from "pinia";
import AzureGraphDataFetcher from "@/services/connectors/azureGraphConnector";
import { useAuthenticationStore } from "./authentication";
import { reactive } from "vue";

// const authorozationStore = useAuthenticationStore();
// const graph = new AzureGraphDataFetcher(useAuthenticationStore().getToken);

export const useAzureStore = defineStore("azure", () => {
  const graph = new AzureGraphDataFetcher(
    useAuthenticationStore().getTokenLoaded()
  );
  const state = reactive({
    userPhoto: {
      blob: null as Blob | null,
      loader: false,
    },
    userManager: {
      data: null,
      loader: false,
    },
    isOwner: false,
  });
  // const groupMembers = [];

  // async function loadPhoto() {
  //     userPhoto.loader = true;
  //     const result = await graph.getMyPhoto();
  //     userPhoto.blob = result;
  //     userPhoto.loader = false;
  // }

  async function loadUserManager(id: string) {
    try {
      state.userManager.loader = true;
      const result = await graph.getUserManager(id);
      state.userManager.data = result;
    } catch (e) {
      console.error(e);
    } finally {
      state.userManager.loader = false;
    }
  }

  async function loadIsUserOwner() {
    try {
      state.isOwner = await graph.isCurrentUserMemberOfGroup();
    } catch (error) {
      console.error("Error checking user ownership:", error);
      return false;
    }
  }

  async function getPageDescription(id: string): Promise<any> {
    try {
      const result = await graph.getPageDescription(id);
      return result;
    } catch (error) {
      console.error("Error fetching page description:", error);
      throw error;
    }
  }

  async function getReportLink(reportName: string): Promise<any> {
    try {
      const result = await graph.getReportLink(reportName);
      const pageTitle = result.data.value[0].fields.Title;
      if (pageTitle) {
        document.title = document.title + " - " + pageTitle;
      }
      return result.data;
    } catch (error) {
      console.error("Error fetching report link:", error);
      throw error;
    }
  }
  // function getGroupMembers(): any[] {
  //     return groupMembers;
  // }
  function getUserManager(): any {
    return state.userManager.data;
  }
  function getUserManagerLoader(): boolean {
    return state.userManager.loader;
  }
  function isUserOwner(): boolean {
    return state.isOwner;
  }

  return {
    getReportLink,
    getPageDescription,
    isUserOwner,
    loadIsUserOwner,
    loadUserManager,
    getUserManager,
    getUserManagerLoader,
  };
});
